const AciHighwayManifestNoteLogApiUrls = {
    GET: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/manifestNoteLog/get`,
    POST: `${process.env.REACT_APP_USER_ACIHW_URL}/aci-highway/manifestNoteLog/create`,
};

export default AciHighwayManifestNoteLogApiUrls
